<template>
    <el-drawer
        title="管理群组"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        :size="400"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                
                <el-form-item prop="name" label="群组名称:">
                    <el-input v-model="formData.name" placeholder="请输入群组名称" maxlength="40" show-word-limit autosize type="textarea"></el-input>
                </el-form-item>
                <el-form-item prop="owner" label="群主:">
                    <el-select
                        v-model="formData.owner"
                        filterable
                        remote
                        placeholder="请选择群主"
                        :remote-method="searchMainUser"
                        :loading="userLoading"
                        value-key="id">
                        <el-option
                            v-for="item in mainUserList"
                            :key="item.id"
                            :label="`${item.name}(${item.id})`"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="adminList" label="群管理:">
                    <el-select
                        v-model="formData.adminList"
                        multiple
                        filterable
                        remote
                        placeholder="请选择群组管理"
                        :remote-method="searchAdminUser"
                        :loading="userLoading"
                        value-key="id">
                        <el-option
                            v-for="item in adminUserList"
                            :key="item.id"
                            :label="`${item.name}(${item.id})`"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
import {fetchUser} from '@/assets/js/commonApi';
const defaultData = {
    id:"",
    name: "",
    isAddHost: 1,
    adminList:[],
    owner: null
}
export default {
    
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData:{
                ...defaultData
            },
            
            rules:{
                name:[{ required: true, message: "请填写名称" }],
                owner: [{required: true, message: "请选择群主"}]
            },

            userLoading: false,
            mainUserList: [],
            adminUserList:[],
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData,
                adminList:[],
            }
            this.mainUserList = [];
            this.adminUserList = [];
        },
        show(id){
            if( id ){
                this.formData.id = id;
                this.getData();
            }
            this.drawerShow = true;
        },
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/group/detail',
                params: {groupId: this.formData.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.formData = {
                            ...this.formData,
                            ...result
                        }

                        if(result.owner) this.mainUserList.push(result.owner);
                        this.adminUserList = result.adminList || [];

                    } else {
                        this.$message.error(msg || "请求失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("请求失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });  
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/group/updateGroup',
                        data: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        },
        async searchMainUser(query){
            this.searchUser(query,'mainUserList');
        },
        async searchAdminUser(query){
            this.searchUser(query,'adminUserList');
        },
        // 查找用户
        async searchUser(query,type){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                    userType: 0
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    if( type == 'mainUserList' ){
                        this.mainUserList = result
                    }
                    if( type == 'adminUserList' ){
                        this.adminUserList = result
                    }
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>